import React from 'react'

import {Link} from "react-router-dom";
import Navbar from '../inc/Navbar';
import PhotoGallery from './PhotoGallery';

function Photopage() {
    return (
        <div>
            <Navbar />
            <br />
            <br />
            <br />
            <br/>
            
          
            <div className='charitabletrust'>
                <div className="album py-1">

                    <div className="container  mt-4">

                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/" >Home</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Photo Gallery </li>
                            </ol>
                        </nav>
                    </div>
                </div>
                </div>
                <br/>
                <PhotoGallery />
                <br/>
            </div>
            )
}

            export default Photopage